<template>
  <div>
    <button class="button-back" @click="backButtonClicked">
      <img :src="require(`@/assets/img/icon/svg/button-back.svg`)" />
    </button>
    <h1 class="heading">{{ headerTitle }}</h1>
  </div>
</template>

<script>
export default {
  name: "MFITTHeader",

  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    clickBackButtonEvent: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    backButtonClicked() {
      if (this.clickBackButtonEvent) {
        this.clickBackButtonEvent();
      } else {
        this.backToPreviousPage();
      }
    },
    closeButtonClicked() {
      this.returnNativeApp();
    },
  },
};
</script>

<style lang="scss" scoped>
button.button-back {
  z-index: 99;
  left: 5px;
  top: 50px;
  border: none;
  background-color: transparent;
}

button.button-back img {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  box-shadow: var(--defaultBoxShadow);
}
h1.heading {
  margin: 55px 0 40px 50px;
  font-size: 18px;
  font-weight: bold;
}
</style>
